import React from 'react';
import { Loader2, ShieldCheck } from 'lucide-react';

// The order form's foot: the button that places the order, worded and coloured as the merchant set it, and the note
// under it. Shared by every place the form opens, so the popup, the drawer, the page and the product page match.

interface OrderSubmitProps {
  /** What the button says, the total already in it when the merchant shows it. */
  label: string;
  submittingLabel: string;
  submitting: boolean;
  disabled: boolean;
  /** The note under the button, or null when it is hidden. */
  note: string | null;
}

// Draws the order button and the note under it.
export const OrderSubmit: React.FC<OrderSubmitProps> = ({ label, submittingLabel, submitting, disabled, note }) => (
  <>
    <button type="submit" className="btn-submit-order" disabled={disabled}>
      {submitting ? (
        <><Loader2 className="animate-spin" size={20} /><span>{submittingLabel}</span></>
      ) : (
        <><ShieldCheck size={20} /><span dir="auto">{label}</span></>
      )}
    </button>
    {note !== null && (
      <div className="checkout-secure-note" style={{ textAlign: 'center', fontSize: 12, color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
        <ShieldCheck size={14} color="#059669" />
        <span dir="auto">{note}</span>
      </div>
    )}
  </>
);

export default OrderSubmit;
